module.exports = __webpack_public_path__ + "img/slika19.701dfcba.jpg";